import {
  SET_INNER_MODAL_OPENED,
  SET_COLLAPSABLE_EXPANDED_ITEMS,
  SET_LOCATION_PARAMS,
  TOGGLE_COLLAPSABLE_EXPANDED_ITEM,
  DATE_PICKER_CANCEL,
  SET_LOADING,
} from './_types';

export default {
  [SET_INNER_MODAL_OPENED]: (state, { facetName, isOpen }) => {
    state.innerModalsOpened[facetName] = isOpen;
  },
  [SET_COLLAPSABLE_EXPANDED_ITEMS]: (state, items) => {
    state.collapsableExpandedItems = items;
  },
  [SET_LOCATION_PARAMS]: (state, locationParams) => {
    state.locationParams = locationParams;
  },
  [TOGGLE_COLLAPSABLE_EXPANDED_ITEM]: (state, { facetName, category, expanded }) => {
    state.collapsableExpandedItems[facetName][category] = expanded;
  },
  [DATE_PICKER_CANCEL]: (state, cancel) => {
    state.datePickerCancelled = cancel;
  },
  [SET_LOADING]: (state, value) => {
    state.isLoading = value;
  },
};
